/* istanbul ignore file */
export * from './InspiringSearchMoreCard';
